import { Card, Chip, Modal, ModalContent, useDisclosure } from '@nextui-org/react'
import SelectTank from '../../pages/SelectTank'
import useHomeAssignGroupStore from '../../store/home/useHomeAssignGroupStore'
import type { SelectedTankArray } from '@/types/view'

export const SelectUngroupedTanksCard = () => {
  const { selectedTanks, setSelectedTanks, selectTanksBorderColor } = useHomeAssignGroupStore()
  const {
    isOpen: isOpenTanks,
    onOpen: onOpenTanks,
    onOpenChange: onOpenChangeTanks,
  } = useDisclosure()

  return (
    <>
      <div className="mt-3 font-bold" data-testid="ungrouped-tanks-label">
        Select Ungrouped Tanks
      </div>
      <Card
        className={`${selectTanksBorderColor} border-opacity-60`}
        radius="md"
        shadow="sm"
        isPressable
        onPress={onOpenTanks}
        data-testid="ungrouped-tanks-field"
        role="button"
        aria-label="Ungrouped tanks selection field"
        tabIndex={0}
      >
        <Modal
          isOpen={isOpenTanks}
          onOpenChange={onOpenChangeTanks}
          isDismissable={false}
          isKeyboardDismissDisabled={true}
          size="3xl"
          scrollBehavior="inside"
          data-testid="ungrouped-tanks-selection-modal"
          classNames={{
            wrapper: 'z-[1500]',
            backdrop: 'z-[1450]',
            base: 'max-h-[85vh] sm:max-h-[90vh] md:max-h-[95vh]',
          }}
        >
          <ModalContent
            className="overflow-x-hidden"
            data-testid="ungrouped-tanks-selection-modal-content"
          >
            {(onCloseTanks) => (
              <SelectTank
                submitTankArray={(tankSelectedList: SelectedTankArray) =>
                  setSelectedTanks(tankSelectedList)
                }
                groupIds={['$ungrouped']}
                onClose={onCloseTanks}
                initialTankArray={selectedTanks}
              />
            )}
          </ModalContent>
        </Modal>
        <div
          className="flex flex-row flex-wrap justify-start p-1 min-h-[3rem] max-h-[10rem] overflow-y-auto"
          style={{ touchAction: 'pan-y', WebkitOverflowScrolling: 'touch' }}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {selectedTanks.map((item, index) => (
            <Chip
              key={index}
              radius="md"
              classNames={{
                base: 'border-small border-tdpldarkgrey bg-tdplsky border-opacity-60 m-1 p-0',
                content: 'font-bold',
              }}
              data-testid={`selected-ungrouped-tank-chip-${item.tankName}`}
            >
              {item.tankName}
            </Chip>
          ))}
          {selectedTanks.length === 0 && (
            <div
              className="flex items-center justify-center text-gray-500 text-sm min-h-[2rem] w-full"
              data-testid="ungrouped-tanks-placeholder"
            >
              Click to select ungrouped tanks
            </div>
          )}
        </div>
      </Card>
      {selectTanksBorderColor && selectTanksBorderColor.includes('tdplmaroon') ? (
        <p
          className="m-0 text-sm font-semibold text-tdplmaroon"
          data-testid="ungrouped-tanks-error"
        >
          You need to select at least one ungrouped tank.
        </p>
      ) : (
        <p data-testid="ungrouped-tanks-error-placeholder"> </p>
      )}
    </>
  )
}
